module.exports = "<gantt-chart gantt-series=$ctrl.ganttSeries></gantt-chart>";